import { MoveTankFormModes, MoveTankService } from './../../services/move-tank.service';
import { SecurityPolicies } from '@services/auth-variables';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppSettings } from 'src/app/shared/Constants/sharedConstants';

export interface BeforeOpenPayload {
  cancel: boolean;
  context: object;
  proceed: () => void;
}


@Component({
  selector: 'app-tank-move-button',
  templateUrl: './tank-move-button.component.html',
  styleUrls: ['./tank-move-button.component.css'],
})
export class TankMoveButtonComponent {
  @Input() uniqueId: number | null = null;
  @Input() locationId: number | null = null;
  @Input() organizationId: number | null = null;
  @Input() billableOrganizationId: number | null = null;
  @Input() tankSourceOrganizationId: number | null = null;
  @Input() buttonText: string = 'placeholder';
  @Input() formMode: MoveTankFormModes = null;
  @Output() moveComplete = new EventEmitter<void>();
  @Output() beforeOpen = new EventEmitter<BeforeOpenPayload>();
  @Input() outlined: boolean = true;
  @Input() showAsCollapsed: boolean = false;
  @Input() context: object = {};
  SecurityPolicies = SecurityPolicies;
  readonly Features = AppSettings.UIAppConfig.features;

  _disabled = false;
  get disabled() {
    return (
      this._disabled ||
      !this.Features.moveTank ||
      this.Features.moveTank !== true
    );
  }
  @Input()
  set disabled(value: boolean) {
    this._disabled = value;
  }

  constructor(private moveTankService: MoveTankService) {}

  onClick() {
    const payload: BeforeOpenPayload = {
      context: this.context,
      cancel: false,
      proceed: () => this.showMoveTankDialog()
    }
    
    this.beforeOpen.emit(payload);
    
    setTimeout(() => {
      if (payload.cancel) return;
      payload.proceed();
    });

  }

  private showMoveTankDialog() {
    this.moveTankService.showMoveTankDialog(
      this.formMode,
      this.uniqueId,
      this.locationId,
      this.organizationId,
      this.billableOrganizationId,
      this.tankSourceOrganizationId,
      this.onMoveComplete.bind(this),
    );
  }

  onMoveComplete = () => {
    this.moveComplete.emit();
  };
}
